const locationAndContactStrings = {
    seoTitle: "La Estrellita | Location & Contact",
    pageTitle: "Location & Contact",
    callText: "To reach out or place an order, please call us at",
    contactUs: "Contact Us",
    callBackupText: "If you can't reach us, please try our backup number at ",
    locationText: "We are located at",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    businessHours: "Business Hours",
};

export default locationAndContactStrings;
